/* Kuk koleksiyon ve arama sonuç sayfası (sop/koleksiyon.json 4-6, 14, 18-25; baslik-menu-arama 28-34). Filtre ve sıralama Shopify Section Rendering ile
   sayfa yenilenmeden uygulanır (araç çubuğu, ızgara ve filtre gövdesi birlikte yenilenir), durum URL'de kalır
   (history.pushState), geri tuşu önceki seçime döner. DAHA FAZLA GÖSTER sonraki 24 ürünü ekler (?page= replaceState);
   ürün sayfasından geri gelince önceki sayfalar yeniden yüklenir ve kaydırma konumu geri gelir.
   JS yoksa formlar normal GET, DAHA FAZLA GÖSTER normal bağlantıdır. Ölçüm: 'kuk:olay' view_item_list, select_item. */
(() => {
  if (window.kukFacets) return;
  window.kukFacets = true;
  const { kaydirma, altSayfa, olay } = window.kukOrtak;

  const bolumId = (secici) => {
    const el = document.querySelector(secici);
    const bolum = el && el.closest('.shopify-section');
    return bolum ? bolum.id.replace('shopify-section-', '') : null;
  };
  const temizParametre = (p) => {
    const q = new URLSearchParams(p);
    ['page', 'sections', 'section_id'].forEach((k) => q.delete(k));
    return q;
  };
  const adres = (q) => `${window.location.pathname}${q.toString() ? `?${q}` : ''}`;
  const html = (metin) => new DOMParser().parseFromString(metin, 'text/html');

  let istek = null;
  let yuklenenSorgu = temizParametre(window.location.search).toString();
  const sonSecimler = [];

  // Araç çubuğu hizasına kaydır (yapışkan başlık 59 px altına)
  const aracaKaydir = () => {
    const arac = document.querySelector('.kuk-koleksiyon-bolum--arac') || document.querySelector('[data-kuk-izgara]');
    if (!arac) return;
    const ust = arac.getBoundingClientRect().top + window.scrollY - 59;
    if (window.scrollY > ust) window.scrollTo({ top: ust, behavior: kaydirma() });
  };

  const degistir = (belge, secici) => {
    const yeni = belge && belge.querySelector(secici);
    const eski = document.querySelector(secici);
    if (yeni && eski) eski.replaceWith(yeni);
  };

  // Filtre alt sayfası açıkken yalnız gövde ve buton yenilenir; açık gruplar ve kaydırma korunur
  const filtreGuncelle = (belge) => {
    if (!belge) return;
    const dialog = document.querySelector('[data-kuk-filtre]');
    const yeniDialog = belge.querySelector('[data-kuk-filtre]');
    if (!dialog || !yeniDialog) {
      degistir(belge, '[data-kuk-filtre-bolum]');
      return;
    }
    const govde = dialog.querySelector('[data-filtre-govde]');
    const acik = new Set([...govde.querySelectorAll('details[open]')].map((d) => d.dataset.anahtar));
    const kapali = new Set([...govde.querySelectorAll('details:not([open])')].map((d) => d.dataset.anahtar));
    const kaydirmaKonumu = govde.scrollTop;
    const yeniGovde = yeniDialog.querySelector('[data-filtre-govde]');
    yeniGovde.querySelectorAll('details').forEach((d) => {
      if (acik.has(d.dataset.anahtar)) d.open = true;
      else if (kapali.has(d.dataset.anahtar)) d.open = false;
    });
    govde.replaceWith(yeniGovde);
    yeniGovde.scrollTop = kaydirmaKonumu;
    dialog.querySelector('.kuk-filtre__alt').replaceWith(yeniDialog.querySelector('.kuk-filtre__alt'));
    const siralaDialog = document.querySelector('[data-kuk-sirala]');
    const yeniSirala = belge.querySelector('[data-kuk-sirala] form');
    if (siralaDialog && yeniSirala && !siralaDialog.open) siralaDialog.querySelector('form').replaceWith(yeniSirala);
    const gizliSirala = dialog.querySelector('input[name="sort_by"]');
    const yeniGizli = yeniDialog.querySelector('input[name="sort_by"]');
    if (gizliSirala) gizliSirala.remove();
    if (yeniGizli) dialog.querySelector('[data-filtre-form]').append(yeniGizli);
  };

  const yukleniyor = (acik) => {
    document.querySelector('[data-kuk-sayi]')?.classList.toggle('is-yukleniyor', acik);
    document.querySelector('[data-kartlar]')?.classList.toggle('is-yukleniyor', acik);
    const goster = document.querySelector('[data-filtre-goster]');
    if (goster) goster.classList.toggle('is-yukleniyor', acik);
  };

  const yenile = async (parametreler, { gecmis = 'push', kaydir = false } = {}) => {
    const q = temizParametre(parametreler);
    const url = adres(q);
    // Arama sonuç sayfasında sonuç cümlesi de yenilenir ([data-kuk-arama-bas])
    const idler = [bolumId('[data-kuk-arac]'), bolumId('[data-kuk-izgara]'), bolumId('[data-kuk-filtre-bolum]'), bolumId('[data-kuk-arama-bas]')].filter(Boolean);
    if (istek) istek.abort();
    istek = new AbortController();
    yukleniyor(true);
    try {
      const yanit = await fetch(`${url}${q.toString() ? '&' : '?'}sections=${idler.join(',')}`, { signal: istek.signal });
      if (!yanit.ok) throw new Error(String(yanit.status));
      const veri = await yanit.json();
      const belgeler = Object.fromEntries(Object.entries(veri).map(([k, v]) => [k, html(v)]));
      const id = (secici) => bolumId(secici);
      degistir(belgeler[id('[data-kuk-arac]')], '[data-kuk-arac]');
      degistir(belgeler[id('[data-kuk-arama-bas]')], '[data-kuk-arama-bas]');
      degistir(belgeler[id('[data-kuk-izgara]')], '[data-kuk-izgara]');
      filtreGuncelle(belgeler[id('[data-kuk-filtre-bolum]')]);
      yuklenenSorgu = q.toString();
      if (gecmis === 'push') window.history.pushState({ kukFiltre: true }, '', url);
      else if (gecmis === 'replace') window.history.replaceState({ kukFiltre: true }, '', url);
      if (kaydir) aracaKaydir();
      listeOlayi();
    } catch (hata) {
      if (hata.name !== 'AbortError') window.location.href = url;
    } finally {
      yukleniyor(false);
    }
  };

  const formParametreleri = (form, ekle) => {
    const q = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') q.append(k, v); });
    if (ekle) Object.entries(ekle).forEach(([k, v]) => q.set(k, v));
    return q;
  };

  // Fiyat alanı: en az, en çoktan büyükse çerçeve #8A5F1F ve hata satırı; uygulanmaz
  const fiyatGecerli = (form) => {
    const alan = form.querySelector('[data-fiyat-alani]');
    if (!alan) return true;
    const enAz = alan.querySelector('[data-fiyat-en-az]');
    const enCok = alan.querySelector('[data-fiyat-en-cok]');
    const hatali = enAz.value !== '' && enCok.value !== '' && Number(enAz.value) > Number(enCok.value);
    enAz.classList.toggle('is-hatali', hatali);
    enCok.classList.toggle('is-hatali', hatali);
    alan.querySelector('[data-fiyat-hata]').hidden = !hatali;
    return !hatali;
  };

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-filtre-form]');
    if (!form) return;
    if (e.target.type === 'checkbox') {
      const anahtar = `${e.target.name}=${e.target.value}`;
      if (e.target.checked) sonSecimler.push(anahtar);
      else sonSecimler.splice(sonSecimler.lastIndexOf(anahtar), 1);
    }
    if (e.target.type === 'number' && !fiyatGecerli(form)) return;
    yenile(formParametreleri(form));
  });

  document.addEventListener('submit', (e) => {
    const filtre = e.target.closest('[data-filtre-form]');
    if (filtre) {
      e.preventDefault();
      if (!fiyatGecerli(filtre)) return;
      const q = formParametreleri(filtre);
      const dialog = filtre.closest('dialog');
      if (q.toString() !== yuklenenSorgu) yenile(q, { kaydir: true });
      else aracaKaydir();
      if (dialog && dialog.open) dialog.close();
      document.querySelector('.kuk-izgara .kuk-kart')?.focus({ preventScroll: true });
      return;
    }
    const sirala = e.target.closest('[data-sirala-form]');
    if (sirala) {
      e.preventDefault();
      const deger = e.submitter && e.submitter.value;
      const dialog = sirala.closest('dialog');
      if (dialog && dialog.open) dialog.close();
      yenile(formParametreleri(sirala, deger ? { sort_by: deger } : null), { kaydir: true });
    }
  });

  document.addEventListener('click', (e) => {
    const ac = e.target.closest('[data-filtre-ac], [data-sirala-ac]');
    if (ac) {
      altSayfa.ac(document.querySelector(ac.matches('[data-filtre-ac]') ? '[data-kuk-filtre]' : '[data-kuk-sirala]'));
      return;
    }
    const kaldir = e.target.closest('[data-filtre-kaldir], [data-filtre-temizle]');
    if (kaldir) {
      e.preventDefault();
      yenile(new URL(kaldir.href, window.location.origin).searchParams, { kaydir: !kaldir.closest('dialog') });
      return;
    }
    const son = e.target.closest('[data-son-secimi-kaldir]');
    if (son) {
      e.preventDefault();
      // En son eklenen filtre kaldırılır; bu oturumda eklenen yoksa Liquid'in verdiği bağlantı kullanılır
      const sonSecim = sonSecimler.pop();
      if (sonSecim) {
        const [k, v] = sonSecim.split('=');
        const q = temizParametre(window.location.search);
        const kalan = q.getAll(k).filter((x) => x !== v);
        q.delete(k);
        kalan.forEach((x) => q.append(k, x));
        yenile(q, { kaydir: true });
      } else yenile(new URL(son.href, window.location.origin).searchParams, { kaydir: true });
      return;
    }
    const daha = e.target.closest('[data-daha-fazla]');
    if (daha) {
      e.preventDefault();
      dahaFazla(daha);
      return;
    }
    const kart = e.target.closest('.kuk-izgara .kuk-kart');
    if (kart) {
      const izgara = document.querySelector('[data-kuk-izgara]');
      olay('select_item', { item_list_id: izgara?.dataset.liste, urun_id: Number(kart.dataset.urunId) });
    }
  });

  window.addEventListener('popstate', () => {
    const q = temizParametre(window.location.search);
    if (q.toString() !== yuklenenSorgu) yenile(q, { gecmis: 'none' });
  });

  // DAHA FAZLA GÖSTER: sonraki sayfanın kartları eklenir, sayaç ve çubuk o sayfanın değerleriyle yenilenir
  const sayfaGetir = async (sayfa) => {
    const q = temizParametre(window.location.search);
    q.set('page', sayfa);
    q.set('section_id', bolumId('[data-kuk-izgara]'));
    const yanit = await fetch(`${window.location.pathname}?${q}`);
    if (!yanit.ok) throw new Error(String(yanit.status));
    return html(await yanit.text());
  };

  const dahaFazla = async (dugme) => {
    if (dugme.classList.contains('is-yukleniyor')) return;
    const izgara = document.querySelector('[data-kuk-izgara]');
    const sonraki = Number(izgara.dataset.sayfa) + 1;
    const metin = dugme.querySelector('[data-daha-fazla-metni]');
    const ilkMetin = metin.textContent;
    dugme.classList.add('is-yukleniyor');
    metin.textContent = dugme.dataset.yukleniyor;
    try {
      const belge = await sayfaGetir(sonraki);
      const yeniKartlar = [...belge.querySelectorAll('[data-kartlar] > li')];
      const liste = izgara.querySelector('[data-kartlar]');
      yeniKartlar.forEach((li) => liste.append(document.importNode(li, true)));
      izgara.querySelector('[data-kuk-daha-fazla]').replaceWith(document.importNode(belge.querySelector('[data-kuk-daha-fazla]'), true));
      izgara.dataset.sayfa = sonraki;
      const q = temizParametre(window.location.search);
      q.set('page', sonraki);
      window.history.replaceState(window.history.state, '', adres(q));
      const ilkYeni = liste.children[liste.children.length - yeniKartlar.length];
      ilkYeni?.querySelector('a')?.focus({ preventScroll: true });
    } catch (hata) {
      dugme.classList.remove('is-yukleniyor');
      metin.textContent = dugme.dataset.hata || ilkMetin;
    }
  };

  // Geri gelince: ?page=n ile açılan sayfanın önüne 1..n-1 eklenir, sonra kaydırma konumu geri yüklenir
  const geriYukle = async () => {
    const izgara = document.querySelector('[data-kuk-izgara]');
    if (!izgara) return;
    const sayfa = Number(izgara.dataset.sayfa);
    const anahtar = `kuk-kaydirma:${window.location.pathname}${window.location.search}`;
    let kayit = null;
    try { kayit = JSON.parse(sessionStorage.getItem(anahtar) || 'null'); } catch (hata) { kayit = null; }
    if (sayfa > 1) {
      const liste = izgara.querySelector('[data-kartlar]');
      try {
        for (let s = sayfa - 1; s >= 1; s -= 1) {
          const belge = await sayfaGetir(s);
          const kartlar = [...belge.querySelectorAll('[data-kartlar] > li')].map((li) => document.importNode(li, true));
          liste.prepend(...kartlar);
        }
      } catch (hata) { /* önceki sayfalar gelmezse bu sayfa kalır */ }
    }
    if (kayit && typeof kayit.y === 'number') window.scrollTo(0, kayit.y);
  };

  const konumKaydet = () => {
    try { sessionStorage.setItem(`kuk-kaydirma:${window.location.pathname}${window.location.search}`, JSON.stringify({ y: window.scrollY })); } catch (hata) { /* gizli pencere */ }
  };
  window.addEventListener('pagehide', konumKaydet);

  // Ölçüm: listede görünen ürünler (ilk yükleme ve her yenileme)
  const listeOlayi = () => {
    const izgara = document.querySelector('[data-kuk-izgara]');
    if (!izgara) return;
    const urunler = [...izgara.querySelectorAll('.kuk-kart')].slice(0, 24).map((a) => Number(a.dataset.urunId));
    if (urunler.length) olay('view_item_list', { item_list_id: izgara.dataset.liste, urunler });
  };

  // Rehber metni: 4 satır katlı, 'Devamını oku' / 'Kapat'
  document.addEventListener('click', (e) => {
    const dugme = e.target.closest('[data-rehber-dugme]');
    if (!dugme) return;
    const kutu = dugme.closest('kuk-rehber');
    const acik = kutu.classList.toggle('is-acik');
    dugme.setAttribute('aria-expanded', String(acik));
    dugme.textContent = acik ? dugme.dataset.kapat : dugme.dataset.ac;
    if (!acik) kutu.scrollIntoView({ behavior: kaydirma(), block: 'start' });
  });

  const basla = () => {
    geriYukle();
    listeOlayi();
    // Rehber metni 4 satıra sığıyorsa 'Devamını oku' gizlenir
    document.querySelectorAll('kuk-rehber').forEach((k) => {
      const govde = k.querySelector('[data-rehber-govde]');
      if (govde && govde.scrollHeight <= govde.clientHeight + 2) k.querySelector('[data-rehber-dugme]').hidden = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
